import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { MemberProps } from '../../convention'

type Props = {
  loading?: boolean
}

const UpdateCard: React.FC<MemberProps<IRental, Props>> = ({ member, props: { loading } }) => {
  const navigate = useNavigate()
  const { tComponent, tButtonTitle } = useTranslation({
    recordType: RecordType.rental,
    componentType: 'data_display',
    scope: 'card'
  })

  const onClick = () => {
    navigate(Routes.Rental.member(String(member.id)).update)
  }

  return (
    <KCol span={24} card loading={loading}>
      <h3 className="mb-0">{tComponent({ id: 'update_card_title' })}</h3>
      <p>{tComponent({ id: 'update_card_description' })}</p>
      <Button type="secondary" block onClick={onClick} title={tButtonTitle({ id: 'update' })} />
    </KCol>
  )
}

export default UpdateCard
